import { FC } from 'react';
import { MenuPlacement } from 'react-select';
import { RobotoFont } from '../../../styles/fonts';
import dynamic from 'next/dynamic';

const ReactSelect = dynamic(() => import('react-select'), { ssr: false });

type Props = {
  className?: string;
  id?: string;
  value: any;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onInputChange?: (e: string) => void;
  options: any[];
  withRs?: boolean;
  placeholder?: string;
  menuPlacement?: MenuPlacement | undefined;
  disabled?: boolean;
  isSearchable?: boolean;
  maxMenuHeight?: number;
  isClearable?: boolean;
  dropdownStyles?: any;
  onFocus?: (e: any) => void;
  loadingText?: string;
};

const customStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '14px',
    fontFamily: `${RobotoFont.style.fontFamily}, Helvetica,Arial,sans-serif`,
    backgroundColor: '#f0f4f8',
    color: '#7d8286',
    '&:hover': {
      backgroundColor: '#e6f5fe',
    },
  }),
  input: (provided: any) => ({
    ...provided,
    padding: '6.2px 0',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: `${RobotoFont.style.fontFamily}, Helvetica,Arial,sans-serif`,
    color: '#7d8286',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: `${RobotoFont.style.fontFamily}, Helvetica,Arial,sans-serif`,
  }),
  singleValue: (provided: any) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: `${RobotoFont.style.fontFamily}, Helvetica,Arial,sans-serif`,
    color: '#7d8286',
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    outline: 'none',
    fontFamily: `${RobotoFont.style.fontFamily}, Helvetica,Arial,sans-serif`,
    boxShadow: 'none',
    color: '#7d8286',
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    zIndex: 5,
    backgroundColor: '#f0f4f8',
  }),
  dropdownIndicator: (provided: any) => ({
    paddingRight: 5,
    paddingTop: 4,
  }),
};

const Select: FC<Props> = ({
  className,
  isSearchable = true,
  id,
  value,
  onChange,
  onBlur,
  onInputChange,
  options,
  withRs,
  placeholder,
  menuPlacement,
  disabled,
  maxMenuHeight,
  isClearable = true,
  dropdownStyles,
  onFocus,
  loadingText,
}) => {
  return (
    <ReactSelect
      onBlur={onBlur}
      openMenuOnFocus={true}
      value={value}
      options={options}
      onChange={onChange}
      styles={dropdownStyles || customStyles}
      placeholder={placeholder}
      components={{ IndicatorSeparator: () => null }}
      isClearable={isClearable}
      menuPlacement={menuPlacement}
      maxMenuHeight={maxMenuHeight || 150}
      isDisabled={disabled}
      isSearchable={isSearchable}
      captureMenuScroll
      className={className}
      onFocus={onFocus}
      noOptionsMessage={({ inputValue }) => (!inputValue ? loadingText || 'Loading...' : 'No results found')}
    />
  );
};

export { Select };
